// extracted by mini-css-extract-plugin
export var productImage = "_q4-1";
export var viewLink = "_q4-2";
export var wishlistItem = "_q4-0";